import React from 'react';

import { makeStyles, createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { DialogProps } from '@material-ui/core/Dialog/Dialog';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

/**
 * 使用例
 */
// const [open, setOpen] = React.useState(false);

// const handleClickOpen = () => {
//   setOpen(true);
// };
// const handleClose = () => {
//   setOpen(false);
// };

//  <SimpleDialog open={open} onClose={handleClose} title={'タイトルです'} okText="閉じる">
//    <Typography>Hello body</Typography>
//  </SimpleDialog>;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

type DialogTitleProps = {
  children: React.ReactNode;
  onClose: () => void;
};

const DialogTitle: React.FC<DialogTitleProps> = (props) => {
  const { children, onClose, ...other } = props;
  const classes = useStyles(props);
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export type SimpleDialogProps = {
  /**画面外にマウスをクリックで画面を閉じる */
  autoClose?: boolean;
  /**ダイアログタイトル */
  title?: React.ReactNode | React.ReactNodeArray;
  /**ダイアログコンテント */
  children?: React.ReactNode | React.ReactNodeArray;
  /**ダイアログフッター　未使用 */
  footer?: React.ReactNode | React.ReactNodeArray;
  /**ボタン表示 */
  okText?: string;
  /**表示/非表示コントロール用 */
  open: boolean;
  /**画面外にマウスをクリックで画面を閉じる */
  maxWidth?: DialogProps['maxWidth'];
  onClose: () => void;
};

export const SimpleDialog: React.FC<SimpleDialogProps> = (props) => {
  const classes = useStyles();
  const { autoClose = false, title, open, children, okText, maxWidth = 'md', onClose } = props;
  return (
    <Dialog
      onClose={(e) => {
        if (autoClose) {
          onClose();
        }
      }}
      open={open}
      fullWidth={true}
      maxWidth={maxWidth}
    >
      <DialogTitle onClose={onClose}>{title}</DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      {okText && (
        <DialogActions>
          <Button autoFocus variant="contained" color="primary" startIcon={<CloseIcon />} onClick={onClose}>
            {okText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};
export default SimpleDialog;
